import './styles.css'
import React, { useEffect, useState } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import { Box, Text, Card, Flex, Button, Input } from 'theme-ui'
import { Stack, Main, Hero } from '@layout'
// import PageTitle from '@components/PageTitle'
import Divider from '@components/Divider'
// import Section from '@components/Section'
import Section from '../components/Section'
import Seo from '@widgets/Seo'
import HeroComponent from '../components/Hero/Hero'
import HeroQuoteComponent from '../components/HeroQuote/Hero'
import SubscriptionsCTA from '@widgets/SubscriptionsCTA'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion'
import 'react-accessible-accordion/dist/fancy-example.css'

const styles = {
  imageWrapper: {
    // borderRadius: `default`,
    overflow: `hidden`,
    position: `relative`,
    textAlign: 'center',
    my: '30px',
    grayscale: {
      // WebkitFilter: `grayscale(1)`,
      // filter: `grayscale(1)`,
      // opacity: `0.7`,
      mb: '30px',
      maxWidth: '100%'
      // '&:hover': {
      // }
    },
    img: {
      // height: 'auto !important',
    }
  },
  button: {
    display: [`none`, `block`],
    position: `absolute`,
    bottom: 4,
    right: 4
  },
  grid: {
    flexWrap: [`wrap`, `wrap`, `nowrap`],
    ' > div + div': {
      ml: [0, 0, 5]
    },
    alignItems:'center',
  },
  gridIconWrapper:{
    boxShadow: '3px 3px 4px 0 rgb(1 1 1 / 15%)',
    borderRadius: '10px',
  },
  column: {
    flex: `auto`,
    flexBasis: [`full`, `full`, `1/2`],
    marginTop: '1rem',
    marginBottom: '1rem',
  },
  hero: {
    // bg: `contentBg`,
    backgroundImage:
      'linear-gradient(231deg, rgba(233, 233, 233, 0.01) 0%, rgba(233, 233, 233, 0.01) 25%,rgba(10, 10, 10, 0.01) 25%, rgba(10, 10, 10, 0.01) 50%,rgba(237, 237, 237, 0.01) 50%, rgba(237, 237, 237, 0.01) 75%,rgba(200, 200, 200, 0.01) 75%, rgba(200, 200, 200, 0.01) 100%),linear-gradient(344deg, rgba(2, 2, 2, 0.03) 0%, rgba(2, 2, 2, 0.03) 20%,rgba(10, 10, 10, 0.03) 20%, rgba(10, 10, 10, 0.03) 40%,rgba(100, 100, 100, 0.03) 40%, rgba(100, 100, 100, 0.03) 60%,rgba(60, 60, 60, 0.03) 60%, rgba(60, 60, 60, 0.03) 80%,rgba(135, 135, 135, 0.03) 80%, rgba(135, 135, 135, 0.03) 100%),linear-gradient(148deg, rgba(150, 150, 150, 0.03) 0%, rgba(150, 150, 150, 0.03) 14.286%,rgba(15, 15, 15, 0.03) 14.286%, rgba(15, 15, 15, 0.03) 28.572%,rgba(74, 74, 74, 0.03) 28.572%, rgba(74, 74, 74, 0.03) 42.858%,rgba(175, 175, 175, 0.03) 42.858%, rgba(175, 175, 175, 0.03) 57.144%,rgba(16, 16, 16, 0.03) 57.144%, rgba(16, 16, 16, 0.03) 71.42999999999999%,rgba(83, 83, 83, 0.03) 71.43%, rgba(83, 83, 83, 0.03) 85.71600000000001%,rgba(249, 249, 249, 0.03) 85.716%, rgba(249, 249, 249, 0.03) 100.002%),linear-gradient(122deg, rgba(150, 150, 150, 0.01) 0%, rgba(150, 150, 150, 0.01) 20%,rgba(252, 252, 252, 0.01) 20%, rgba(252, 252, 252, 0.01) 40%,rgba(226, 226, 226, 0.01) 40%, rgba(226, 226, 226, 0.01) 60%,rgba(49, 49, 49, 0.01) 60%, rgba(49, 49, 49, 0.01) 80%,rgba(94, 94, 94, 0.01) 80%, rgba(94, 94, 94, 0.01) 100%),linear-gradient(295deg, rgba(207, 207, 207, 0.02) 0%, rgba(207, 207, 207, 0.02) 25%,rgba(47, 47, 47, 0.02) 25%, rgba(47, 47, 47, 0.02) 50%,rgba(142, 142, 142, 0.02) 50%, rgba(142, 142, 142, 0.02) 75%,rgba(76, 76, 76, 0.02) 75%, rgba(76, 76, 76, 0.02) 100%),linear-gradient(73deg, rgba(81, 81, 81, 0.03) 0%, rgba(81, 81, 81, 0.03) 12.5%,rgba(158, 158, 158, 0.03) 12.5%, rgba(158, 158, 158, 0.03) 25%,rgba(136, 136, 136, 0.03) 25%, rgba(136, 136, 136, 0.03) 37.5%,rgba(209, 209, 209, 0.03) 37.5%, rgba(209, 209, 209, 0.03) 50%,rgba(152, 152, 152, 0.03) 50%, rgba(152, 152, 152, 0.03) 62.5%,rgba(97, 97, 97, 0.03) 62.5%, rgba(97, 97, 97, 0.03) 75%,rgba(167, 167, 167, 0.03) 75%, rgba(167, 167, 167, 0.03) 87.5%,rgba(22, 22, 22, 0.03) 87.5%, rgba(22, 22, 22, 0.03) 100%),linear-gradient(90deg, hsl(137,0%,23%),hsl(137,0%,23%))'
  },
  pricing: {
    table: {
      borderRadius: `default`,
      overflow: `hidden`,
      bg: `white`,
      width: '100%',      
    },
    tr: {
      '&:nth-of-type(even)': {
        bg: `#f1f5fb`
      },
      textAlign: 'center'
    },
    th: {
      bg: `omegaLighter`,
      color: `omegaDarker`,
      fontWeight: `600`,
      p: 2,
      '&:first-of-type': {
        pl: 3
      },
      '&:last-of-type': {
        pr: 3
      }
    },
    td: {
      borderBottomWidth: 0,
      p: 2,
      '&:first-of-type': {
        pl: 3
      },
      '&:last-of-type': {
        pr: 3
      }
    },
    p: {
      pt: 0,
      mt: 0
    },
  },
  pricingPlan: {
    bg: `#f6f7f9`,
    minHeight: '500px',
    boxShadow: '0px 4px 27px -8px rgb(0 0 0 / 75%)',
  },
  pricingBtn:{
    minWidth: '15rem',
    fontWeight: 600,
  },
  giftingPlan: {
    bg: `#f6f7f9`,
    minHeight: '500px',
    boxShadow: '0px 4px 27px -8px rgb(0 0 0 / 75%)',
  },
  partners: {},
  quickLinks: {
    a: {
      m: '10px !important'
    }
  },
}

export default props => {
  const data = useStaticQuery(subscriptionQuery)
  const { partnerShopify, partnerRecharge, partnerKlaviyo, subscriptionCancellations } = data
  const fixedShopify =
    (partnerShopify &&
      partnerShopify.childImageSharp &&
      partnerShopify.childImageSharp.fixed) ||
    {}
  const fixedRecharge =
    (partnerRecharge &&
      partnerRecharge.childImageSharp &&
      partnerRecharge.childImageSharp.fixed) ||
    {}
  const fixedKlaviyo =
    (partnerKlaviyo &&
      partnerKlaviyo.childImageSharp &&
      partnerKlaviyo.childImageSharp.fixed) ||
    {}
  const fixedSubscriptionCancellations =
    (subscriptionCancellations &&
      subscriptionCancellations.childImageSharp &&
      subscriptionCancellations.childImageSharp.fixed) ||
    {}



  const [subscribers, setSubscribers] = useState(0)
  const [cost, setCost] = useState(null)

  useEffect(() => {
    const count = parseInt(subscribers)

    if (count === 0) {
      setCost(null)
      return
    }

    let price = 10 // base price

    if (count > 100 && count < 2501) {
      price = price + (count - 100) * 0.04
    }

    if (count > 2500 && count < 7501) {
      price = price + (2500 - 100) * 0.04
      price = price + (count - 2500) * 0.03
    }

    if (count > 7500) {
      price = price + (2500 - 100) * 0.04
      price = price + (5000) * 0.03
      price = price + (count - 7500) * 0.02
    }

    price = price.toFixed(2)
    const usd = (price * 1.37).toFixed(2)
    setCost(`£${price} (roughly $${usd}) per month.`)
  }, [subscribers])

  return (
    <>
      <Seo
        title="Viadog Subscriptions"
        description="Add free gifts to ReCharge subscription orders automatically. 30 day free trial."
        siteUrl="https://www.viadog.com/subscriptions"
        thumbnail="/ViadogSubscriptions.png"
      />
      <Hero sx={styles.hero}>
        <HeroComponent {...props} />
      </Hero>
      <Divider />
      <Stack>
        <Main>
          {/*<PageTitle
            header='Subscriptions'
            subheader=''
          />
          <Divider />
          <Box sx={styles.imageWrapper}>
            <Button sx={styles.button}>Contact Me</Button>
          </Box>
          <Divider />*/}
          <Flex sx={styles.grid}>
            <Box sx={styles.column}>
              <Section /*title='How it Works'*/>
                <Text variant='p' style={{ fontSize: '2rem' }}>
                  We&apos;ll help you retain your subscription customers for longer and reduce your churn rate, increasing revenue.
                </Text>
              </Section>
            </Box>
            <Box sx={{ ...styles.column, textAlign: 'center' }} >
              <Section title='Quick links'>
                <Card variant='paper' className={'sub'}>
                  <Box variant='buttons.group' sx={styles.quickLinks}>
                    <Button
                      variant='primary'
                      as={Link}
                      to='https://subscriptions.viadog.com/register'
                      target='_blank'
                    >
                      Register
                    </Button>
                    <Button
                      variant='white'
                      as={Link}
                      to='https://subscriptions.viadog.com/'
                      target='_blank'
                    >
                      Sign In
                    </Button>
                    <Button
                      variant='white'
                      as={Link}
                      to='https://schedule.viadog.com'
                      target='_blank'
                    >
                      Book a Demo
                    </Button>
                    <Button variant='white' as={Link} to='/contact'>
                      Contact Us
                    </Button>
                  </Box>
                </Card>
              </Section>

            </Box>
          </Flex>
        </Main>
      </Stack>



      <Divider space={3} />
      <Stack>
        <Main>
          <Section title='ReCharge Churn Analysis' style={{ margin: 0 }}>
            <Flex sx={styles.grid}>
              <Box sx={styles.column}>
                <Text variant='p'>
                  Free for all users. The first step to improving your churn rate is to better understand your customers.
                </Text>
                <Text variant='p'>
                  Our deep dive analysis will help to answer questions such as:
                </Text>
                <ul>
                  <li>Which order numbers are customers dropping off at?</li>
                  <li>Why are people cancelling?</li>
                  <li>Do the reasons change over time?</li>
                  <li>What causes orders to fail?</li>
                  <li>What affects are discounts having on retention?</li>
                  <li>What are my most popular/profitable products?</li>
                  <li>Who are my best customers?</li>
                  <li>Who is about to churn?</li>
                </ul>
                <Text variant='p'>
                  With all this information and more, you can take the guesswork out of subscription retention.
                </Text>

                <Box
                  variant='buttons.group'
                  sx={{ marginBottom: [`1rem`, `3rem`] }}
                >
                  <Button
                    variant='primary'
                    as={Link}
                    to='https://subscriptions.viadog.com/register'
                    target='_blank'
                  >
                    Get Started
                  </Button>
                  <Button
                    variant='white'
                    as={Link}
                    to='https://schedule.viadog.com'
                    target='_blank'
                  >
                    Book a Demo
                  </Button>
                </Box>

              </Box>

              <Box sx={styles.column}>
                {fixedSubscriptionCancellations && (
                  <Img
                    fixed={fixedSubscriptionCancellations}
                    style={styles.imageWrapper.grayscale}
                  />
                )}
              </Box>
            </Flex>

          </Section>
        </Main>
      </Stack>
      <Divider space={3} />
      <Stack>
        <Main>
          <Section title='ReCharge Gifting'>
            <Text variant='p'>
              It's 5-7 times cheaper to retain a customer than it is to acquire a new one.
            </Text>
            <Text variant='p'>
              Incentivise your customers with proactive rewards to help reduce churn by
              automatically offering different gifts depending on how many
              times they've ordered in the past.
            </Text>
            <Text variant='p'>
              If you're currently gifting, chances are you're managing it with
              Post-it notes or spreadsheets. We can automate the entire process.
            </Text>
            <Text variant='p'>
              <ul>
                <li>Gifts can include free shipping, a discount on the upcoming order, or any Shopify product</li>
                <li>Add a gift to any ReCharge order, the first, second, fifth etc</li>
                <li>We'll work with you to analyse your subscription performance and gifting strategy</li>
                <li>Gifts are added a few days before the order is due</li>
                <li>
                  All gifts are one-off and won't affect any regular
                  recurring orders
                </li>
              </ul>
            </Text>
            <Text variant='p'>
              Coming soon: Bulk one-off gifting, reward your current subscribers by adding a one time gift to their next order. Contact us to register your interest.
            </Text>
          </Section>
        </Main>
      </Stack>


      {/*<Divider space={4} />
      <Stack>
        <Main>
          <Section title='Upselling'>
            <Text variant='p'>
              Coming 2021: Traditionally upsells are done at the checkout, since your
              subscription customers no longer visit your website for any recurring
              orders there is no longer an opportunity to upsell.
            </Text>
            <Text variant='p'>
              This means upsells are a manual task and let's face it, nobody has the time to do it. 
              You're leaving 10-30% of additional revenue on the table.
            </Text>
            <Text variant='p'>
              We solve this problem by automatically upselling right before their order is due to 
              be processed by offering a simple, hassle free experience.
            </Text>
            <Text variant='p'>
              <ul>
                <li>
                  Upsells are offered a few days before the upcoming order
                </li>
                <li>Offer one-time or ongoing products</li>
                <li>Track conversion rates with ease</li>
                <li>Set and forget ruleset</li>
              </ul>
            </Text>
          </Section>
        </Main>
      </Stack>*/}
      <Divider space={3} />
      <Stack>
        <Main>
          <Section title='Pricing'>
            <Text variant='p'>
              We have a simple no-fuss pricing structure based on the number of active subscribers within ReCharge.
          </Text>
            <Card sx={styles.pricing}>
              <table className="pricing-table">
                <thead>
                  <tr>
                    <th>Active Subscribers</th>
                    <th>Monthly Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Flat fee</td>
                    <td>£10</td>
                  </tr>
                  <tr>
                    <td>0 - 100</td>
                    <td>Free</td>
                  </tr>
                  <tr>
                    <td>101 - 2,500</td>
                    <td>£0.04</td>
                  </tr>
                  <tr>
                    <td>2,501 - 7,500</td>
                    <td>£0.03</td>
                  </tr>
                  <tr>
                    <td>7,500 +</td>
                    <td>£0.02</td>
                  </tr>
                </tbody>
              </table>
            </Card>

            <Divider space={3} />

            <Card variant='paper'>
              <Text variant='p'>Enter your number of active subscribers below to get a more accurate price.</Text>
              <Input
                name='subscribers'
                id='subscribers'
                type='number'
                onChange={(event) => setSubscribers(event.target.value || 0)}
              />
              {cost && <Text variant='p' sx={{ mt: 3 }}>{cost}</Text>}
            </Card>


            <Divider space={2} />

            <Flex sx={styles.grid} >
              <Box sx={styles.column}>
                <Card variant='paper' sx={styles.pricingPlan}>

                  <Text variant='h3' sx={styles.planTitle}>Free Plan</Text>
                  <div className="pricing-plan">
                  <Text variant='p'>
                    Analyse your ReCharge subscription data and discover exactly when and why cancellations occur.
                  </Text>
                  <ul>
                    <li>Pinpoint high risk order numbers</li>
                    <li>Reveal the cause of cancellations</li>
                    <li>Identify customers about to churn</li>
                    <li>Churn impact on revenue</li>
                    <li>Highlight your best customers</li>
                    <li>Everything you need to start reducing churn</li>
                  </ul>
                  <Text variant='p'>
                    Includes a 30 day free trial of all our gifting features.
                </Text>
                </div>
                <div>
                  <Button
                    // variant='primary'
                    as={Link}
                    to='https://subscriptions.viadog.com/register'
                    target='_blank'
                    sx={styles.pricingBtn}
                  >
                    Get Started
                  </Button>
                </div>
                </Card>
              </Box>
              <Box sx={styles.column}>
                <Card variant='paper' sx={styles.giftingPlan}>
                  <Text variant='h3'>Gifting Plan</Text>
                  <div className="pricing-plan">
                  <Text variant='p'>
                    Prices start from £10 per month and scale with the size of
                    your business.
                </Text>
                  <ul>
                    <li>Proactive gifting at critical order numbers</li>
                    <li>Gift can be a physical product, discount or free shipping</li>
                    <li>Gifting analytics &amp; reporting</li>
                    <li>Branded emails to notify the customer of the upcoming gift</li>
                    <li><a href='https://gorgias.grsm.io/viadog' rel='noopener noreferrer' target='_blank'>Gorgias</a> and <a href='https://www.klaviyo.com/partner/signup?utm_source=0013o00002U8ppn&utm_medium=partner' rel='noopener noreferrer' target='_blank'>Klaviyo</a> integrations</li>
                  </ul>
                  <Text variant='p'>
                    Each plan starts with a 30 day commitment free trial, no credit card required.
                </Text>
                </div>
                <div>
                  <Button
                    variant='primary'
                    as={Link}
                    to='https://subscriptions.viadog.com/register'
                    target='_blank'
                    sx={styles.pricingBtn}
                  >
                    Start Free Trial
                  </Button>
                  </div>
                </Card>
              </Box>
            </Flex>
          </Section>
        </Main>
      </Stack>
      <Divider space={3} />
      <Stack>
        <Main>
          <Section title='Our Partners'>
            <Text variant='p' style={{ marginBottom: '30px' }}>
              We&apos;re integrated into the same platforms which already power your subscription business.
            </Text>
         
            <Flex sx={{...styles.grid, ...styles.gridIconWrapper}}>
              <Box sx={{ ...styles.column, textAlign: 'center' }}>
                {fixedRecharge && (
                  <Link to='https://shopifysubscriptions.com/affiliate/2867' target='_blank'>
                    <Img
                      fixed={fixedRecharge}
                      style={styles.imageWrapper.grayscale}
                    />
                  </Link>
                )}
              </Box>
              <Box sx={{ ...styles.column, textAlign: 'center' }}>
                {fixedShopify && (
                  <Link to='https://www.shopify.com/' target='_blank'>
                    <Img
                      fixed={fixedShopify}
                      style={styles.imageWrapper.grayscale}
                    />
                  </Link>
                )}
              </Box>
              <Box sx={{ ...styles.column, textAlign: 'center' }}>
                {fixedKlaviyo && (
                  <Link to='https://www.klaviyo.com/partner/signup?utm_source=0013o00002U8ppn&utm_medium=partner' target='_blank'>
                    <Img
                      fixed={fixedKlaviyo}
                      style={styles.imageWrapper.grayscale}
                    />
                  </Link>
                )}
              </Box>
            </Flex>
          </Section>
        </Main>
      </Stack>
      <Divider space={3} />


      {/*<Card variant='paper' sx={styles.partners}>
        We're integrated into the same platforms which already power
        your subscription business.
        <Box sx={styles.imageWrapper}>
          {fixedShopify && (
            <Img
              fixed={fixedShopify}
              style={styles.imageWrapper.grayscale}
            />
          )}
          <Divider space={2} />
          {fixedRecharge && (
            <Img
              fixed={fixedRecharge}
              style={styles.imageWrapper.grayscale}
            />
          )}
        </Box>
      </Card>
          </Section>*/}



      <Hero sx={{ bg: `contentBg` }}>
        <HeroQuoteComponent />
      </Hero>
      <Divider space={3} />
      <Stack>
        <Main>
          <SubscriptionsCTA />
        </Main>
      </Stack>
      <Divider />
      <Stack>
        <Section title='FAQ'>
          
            <Card variant='paper' className="faq-accordian">
            <Accordion>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton style={{ backgroundColor: '#ffffff' }}>
                    Will it work with my website?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={{ backgroundColor: '#e8f1fd' }}>
                  We currently support any Shopify store that uses the ReCharge
                  payment gateway. We plan to support additional payment
                  gateways in the future, contact us for more information.
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton style={{ backgroundColor: '#ffffff' }}>
                  How does gifting work?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={{ backgroundColor: '#e8f1fd' }}>
                A few days before the order is due to be processed, we will check the order history of the customer and add any applicable gifts to the upcoming order. A gift can be a physical product, a discount on the order, or free shipping.
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton style={{ backgroundColor: '#ffffff' }}>
                   Can you add gifts to non-subscription orders?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={{ backgroundColor: '#e8f1fd' }}>
                  No. We focus on one thing and one thing only, subscription
                  orders. We'd be doing you a disservice by spreading ourselves
                  too thinly and trying to do it all.
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton style={{ backgroundColor: '#ffffff' }}>
                    Is it really 'set and forget'?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={{ backgroundColor: '#e8f1fd' }}>
                  Yes, once setup you can sit back and leave the hard work to
                  us. You will only need to make adjustments if your products
                  change however even this won't be 100% necessary.
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton style={{ backgroundColor: '#ffffff' }}>
                    How does the demo work?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={{ backgroundColor: '#e8f1fd' }}>
                  We'll answer any questions you have over a short
                  online meeting whilst we explain how Viadog Subscriptions
                  works and walk you through getting setup. You can chose to
                  connect your own shop or simply watch us guide you through our
                  demo shop.
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton style={{ backgroundColor: '#ffffff' }}>
                  How is billing calculated?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={{ backgroundColor: '#e8f1fd' }}>
                Billing is calculated based on the number of active subscribers you have on the day of your billing anniversary.
                </AccordionItemPanel>
              </AccordionItem>

            </Accordion>
          </Card>
          
          </Section>
      </Stack>
    </>
  )
}

const subscriptionQuery = graphql`
  query SubscriptionQuery {
    partnerShopify: file(absolutePath: { regex: "/partnerShopify.png/" }) {
      childImageSharp {
        fixed(width: 250, quality: 100) {
          ...GatsbyImageSharpFixed_noBase64
        }
      }
    }
    partnerRecharge: file(absolutePath: { regex: "/partnerRecharge.png/" }) {
      childImageSharp {
        fixed(width: 250, quality: 100) {
          ...GatsbyImageSharpFixed_noBase64
        }
      }
    }
    partnerKlaviyo: file(absolutePath: { regex: "/partnerKlaviyoSilver.png/" }) {
      childImageSharp {
        fixed(width: 250, quality: 100) {
          ...GatsbyImageSharpFixed_noBase64
        }
      }
    }
    subscriptionCancellations: file(absolutePath: { regex: "/subscriptionStats.png/" }) {
      childImageSharp {
        fixed(width: 500, quality: 100) {
          ...GatsbyImageSharpFixed_noBase64
        }
      }
    }
  }
`

// const aboutQuery = graphql`
//   query AboutQuery {
//     photo: file(absolutePath: { regex: "/about.(jpeg|jpg|gif|png)/" }) {
//       childImageSharp {
//         fluid(maxWidth: 1140, maxHeight: 500, cropFocus: NORTH) {
//           ...GatsbyImageSharpFluid_noBase64
//           width: presentationWidth
//           height: presentationWidth
//         }
//       }
//     }
//   }
// `
